export default {
    GA_TRACKING_ID: 'G-M5YR6JC3F9', //ga的id
    event(eventCategory, eventAction, eventLabel, eventValue) {
        if (window.gtag) {
            window.gtag('event', eventAction, {
                event_category: eventCategory,
                event_label: eventLabel,
                value: eventValue,
                send_to: this.GA_TRACKING_ID,
            })
        }
    },
    page(page) {
        if (window.gtag) {
            window.gtag('config', this.GA_TRACKING_ID, {
                page_path: page,
            })
        }
    },
}



//////////////////
// WEBPACK FOOTER
// ./static/js/french_ga.js
// module id = uhtu
// module chunks = 20